"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferAssetLibrarySelectionModal = OfferAssetLibrarySelectionModal;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const AssetLibrary_1 = require("@src/components/modules/AssetLibrary");
const react_intl_1 = require("react-intl");
function OfferAssetLibrarySelectionModal({ isOpen, closeModal, setGalleryAssets, galleryAssetIds, onAssetsDelete, }) {
    const assetGalleryRef = react_1.default.useRef(null);
    const intl = (0, react_intl_1.useIntl)();
    react_1.default.useEffect(() => {
        if (galleryAssetIds && assetGalleryRef.current) {
            assetGalleryRef.current.setSelectedAssetIds(galleryAssetIds);
        }
    }, [galleryAssetIds]);
    return ((0, jsx_runtime_1.jsxs)(elements_1.Modal, { title: intl.formatMessage({ id: 'admin.offer.assets.asset_selection.title' }), visible: isOpen, width: 1250, onCancel: closeModal, okText: intl.formatMessage({ id: 'admin.offer.assets.asset_selection.confirm' }), onOk: async () => {
            setGalleryAssets(assetGalleryRef.current.getSelectedAssets());
            closeModal();
        }, forceRender: true, children: [(0, jsx_runtime_1.jsx)("div", { className: "m-t-s m-b-m", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer.assets.asset_selection.description", values: {
                        link: ((0, jsx_runtime_1.jsx)(elements_1.Link, { to: "/admin/kniznica", children: (0, jsx_runtime_1.jsx)("strong", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.asset_library" }) }) })),
                    } }) }), (0, jsx_runtime_1.jsx)(AssetLibrary_1.AssetLibrary, { ref: assetGalleryRef, areDocumentsDisabled: true, isInSelectMode: true, onAssetsDelete: onAssetsDelete })] }));
}
